import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getMetaTags } from './MetaTagApi';

export interface IMetaTag {
  _id: string;
  path: string;
  title: string;
  description: string;
  createdAt: number;
  updateAt?: number;
}

export interface IMetaTagState {
  status: 'idle' | 'loading' | 'rejected';

  metaTags: {
    [key: string]: IMetaTag;
  };
}

const initialState: IMetaTagState = {
  status: 'idle',
  metaTags: {},
};

export const MetaTagSlice = createSlice({
  name: 'meta_tag',
  initialState,
  reducers: {
    resetMetaTags: (state) => {
      state.metaTags = initialState.metaTags;
    },
  },
  extraReducers: (builder) => {
    // List
    builder
      .addCase(getMetaTags.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getMetaTags.fulfilled, (state, action) => {
        state.status = 'idle';

        if (action.payload && action.payload.path) {
          state.metaTags[action.payload.path] = action.payload;
        }
      })
      .addCase(getMetaTags.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const { resetMetaTags } = MetaTagSlice.actions;

export const getMetaTagState = (state: RootState): RootState['metaTag'] =>
  state.metaTag;

export * from './MetaTagApi';
export default MetaTagSlice.reducer;
